import type { FC, PropsWithChildren } from 'react';

import type { PostsRoute } from '@/features/posts/navigation/postsRoute';
import { OverlayLink } from '@/navigation/components/OverlayLink';

type Props = PropsWithChildren<{
  screen: typeof PostsRoute.PostDetail;
  params: { id?: string };
  accessibilityLabel: string;
}>;

// Web: the link is a sibling overlay, never an ancestor of the content, so
// interactive elements inside the card (channel chip) do not end up as nested
// anchors. Pointer transparency is handled via postCardPointer.web.
export const PostCardLink: FC<Props> = ({
  screen,
  params,
  accessibilityLabel,
  children
}) => (
  <>
    {/* eslint-disable-next-line react-native-a11y/has-accessibility-hint */}
    <OverlayLink
      overlay
      screen={screen}
      params={params}
      accessibilityLabel={accessibilityLabel}
    />
    {children}
  </>
);
